var jlDate = function(){

  var elements = document.querySelectorAll("[data-timestamp]");
  for(let e of elements){
    var timestamp = e.getAttribute("data-timestamp");
    console.log(timestamp);
    var date = new Date(parseInt(timestamp));
    console.log(date.toString());
    var localDate = date;
    //var localDate = new Date(date.toString()+" UTC");
    var format = e.getAttribute("data-format");

    if(format && format == "date"){
      e.innerHTML = formatDate(localDate);
    }
    else if(format && format == "datetime"){
      e.innerHTML = formatDateTime(localDate);
    }
    else{
      e.innerHTML = localDate.toString();
    }

  }
 

};

window.addEventListener("DOMContentLoaded",function(){
  jlDate();
});

var formatDate = function(dateObj){
  var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

  return days[dateObj.getDay()] + ", "+months[dateObj.getMonth()] + " " + dateObj.getDate() + ", "+dateObj.getFullYear();
}

var formatDateTime = function(dateObj){
  var hour = dateObj.getHours();
  var suffix = "AM";
  if(hour == 0){
    hour = 12;
  }
  else if(hour > 11){
    suffix = "PM";
    if(hour > 12){
      hour = hour - 12;
    }
  }

  var minute = dateObj.getMinutes();
  if(minute < 10){
    minute = "0" + minute;
  }

  return formatDate(dateObj) + " " + hour + ":" + minute + " " + suffix;
}
